import {
  SLTXFormatRootFileV1,
  SLTXFormatRootFileGroupV1,
  SLTXFormatRootFileGroupOptionV1,
  SLTXFormatRootFileVariantV1,
  SLTXFormatRootFileVariantCompositionV1,
} from './sltx_v1';

import {
  SLTXFormatRootFile,
  SLTXFormatRootFileGroup,
  SLTXFormatRootFileGroupOption,
  SLTXFormatRootFileGroupOptionFolder,
  SLTXFormatRootFileVariant,
  SLTXFormatRootFileVariantComposition,
} from './sltx';

export class SLTXVersionConverterV1ToV2 {

  static separator = '-';

  public static convertFileFormatToV2(rootV1: SLTXFormatRootFileV1): SLTXFormatRootFile {

    const rootV2 = new SLTXFormatRootFile();

    // Copy the root data
    rootV2.version = 2;

    if (rootV1.groups) {
      rootV2.groups = this.convertGroupsToV2(rootV1.groups);
    }

    rootV2.objects = rootV1.objects;
    rootV2.thumbnail = rootV1.thumbnail;

    if (rootV1.variants) {
      rootV2.variants = this.convertVariantsToV2(rootV1.variants);
    }

    return rootV2;
  }

  private static convertGroupsToV2(groups: SLTXFormatRootFileGroupV1[]): SLTXFormatRootFileGroup[] {

    const groupsV2 = groups.map((groupV1) => {

      const groupV2 = new SLTXFormatRootFileGroup();
      groupV2.id = groupV1.id;
      groupV2.name = groupV1.name;
      groupV2.optionsFolders = this.convertGroupOptionsToV2(groupV1.options);
      return groupV2;
    });

    return groupsV2;
  }

  private static convertGroupOptionsToV2(
    optionsV1 : SLTXFormatRootFileGroupOptionV1[],
  ) : SLTXFormatRootFileGroupOptionFolder[] {

    const subGroups : SLTXFormatRootFileGroupOptionFolder[] = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const optionV1 of optionsV1) {
      // Get the option name
      let optionName = optionV1.name;

      // Split the option name into parts
      const optionNameParts = optionName.split(this.separator);

      let groupName = 'Root';

      // If the option name has a separator, it is a sub-option
      if (optionNameParts.length > 1) {
        // If the option name has no separator, it is a root option
        // eslint-disable-next-line prefer-destructuring
        groupName = optionNameParts[0];
        optionName = optionNameParts.slice(1).join(this.separator);
      }

      // Find the group with the same name
      let group = subGroups.find((g) => g.name === groupName);

      if (group === undefined) {
        group = new SLTXFormatRootFileGroupOptionFolder();
        group.name = groupName;
        subGroups.push(group);
      }

      // Create an option V2
      const optionV2 = new SLTXFormatRootFileGroupOption();
      optionV2.id = optionV1.id;
      optionV2.name = optionName;
      optionV2.objectRef = optionV1.objectRef;
      optionV2.thumbnailRef = optionV1.thumbnailRef;

      // Add the option to the group
      group.options.push(optionV2);
    }

    return subGroups;
  }

  private static convertVariantsToV2(
    variants: SLTXFormatRootFileVariantV1[],
  ): SLTXFormatRootFileVariant[] {

    const variantsV2 = variants.map((variantV1) => {

      const variantV2 = new SLTXFormatRootFileVariant();
      variantV2.backgroundColor = variantV1.backgroundColor;
      variantV2.imageRef = variantV1.imageRef;
      variantV2.name = variantV1.name;
      variantV2.thumbnailRef = variantV1.thumbnailRef;
      variantV2.variantComposition = this.convertVariantComposition(variantV1.variantComposition);
      return variantV2;
    });

    return variantsV2;
  }

  private static convertVariantComposition(
    variantCompositionV1: SLTXFormatRootFileVariantCompositionV1[],
  ): SLTXFormatRootFileVariantComposition[] {

    const variantCompositionV2 = variantCompositionV1.map((variantCompositionElementV1) => {

      const variantCompositionElementV2 = new SLTXFormatRootFileVariantComposition();
      variantCompositionElementV2.groupId = variantCompositionElementV1.groupId;
      variantCompositionElementV2.optionId = variantCompositionElementV1.optionId;
      return variantCompositionElementV2;
    });

    return variantCompositionV2;
  }
}
